import { render } from "./Spinner.vue?vue&type=template&id=dd6e6820&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=dd6e6820&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6e6820"]])

export default __exports__